import Rails from "@rails/ujs"
import $ from 'jquery'
import "bootstrap"
import Blacklight from '../blacklight'

if (!window._rails_loaded) Rails.start();

Blacklight.onLoad(function() {
    $('[data-grouped-items-expand-all]').click(function (e) {
        var action = $(this).attr('data-grouped-items-expand-all');
        $(this).closest('dd').find('.grouped-items-accordion .collapse').collapse(action);
        $(this).text(action === 'show' ? 'collapse all' : 'expand all');
        $(this).attr('data-grouped-items-expand-all', action === 'show' ? 'hide' : 'show')
        e.preventDefault();
        return false;
    });

    $('body[data-spy="scroll"]').scrollspy('refresh');

    //Remove thumbnail img if thumbnail fails to load
    $('img.thumbnail, .thumbnail>img').on('error', function() {
        this.remove();
    });
});
